import { css } from "@emotion/css"
import React, { useMemo } from "react"

type Props = {
  direction: "row" | "column"
  spacing: number
  wrapSpacing?: number
  itemClassName?: string
  children: React.ReactNode
}

const Stack = ({ direction, spacing, wrapSpacing = 0, children, itemClassName }: Props) => {
  const style = useMemo(() => {
    const right = direction === "column" ? wrapSpacing : spacing
    const bottom = direction === "column" ? spacing : wrapSpacing

    return css`
      display: flex;
      flex-direction: ${direction};
      flex-wrap: wrap;
      margin-right: -${right}px;
      margin-bottom: -${bottom}px;
      > * {
        &:not(:empty) {
          margin-right: ${right}px;
          margin-bottom: ${bottom}px;
        }
      }
    `
  }, [direction, spacing, wrapSpacing])

  return (
    <div className={style}>
      {React.Children.toArray(children).map((child, i) => (
        <div key={i} className={itemClassName}>
          {child}
        </div>
      ))}
    </div>
  )
}

export default Stack
